<template>

      <div class="list">
            <div>
                <div class="listTop">
                    <span>
                        {{list.batchName}}
                    </span>
                    <span>
                        {{list.editState=='10020001'?'可修改':'已锁定'}}
                    </span>
                </div>
                <div class="listCon">
                    <p> 
                        <span>
                            <span class="label">
                                创建人
                            </span>：
                        </span>
                         
                        <span>
                            {{list.creator}}
                        </span> 
                    </p>
                   <p>
                        <span>
                            <span class="label">
                                 创建时间
                            </span>：
                        </span>
                        <span>
                            {{list.bizCreateTime}}
                        </span> 
                    </p>
                  
                </div>
            </div>
            <div>
                <div class="rightTop">
                    <div>
                        <span v-for="(process,i) in list.segList" :key="process.id" :class="[{'current':process.procLog.operResult=='10020002'},list.type]">
                              
                            
                            <!-- <el-tooltip class="item" effect="light" content="错误提示文字" placement="bottom" v-if="list.type=='error'&&i==list.currentProcess-1">
                                 <img style="width:14px;margin-left:4px;vertical-align: middle;" src="@/assets/img/salary/icon-tuipiao.png"  /> 
                            </el-tooltip> <el-tooltip class="item" effect="light" content="计算中" placement="bottom" v-if="list.type=='loading'&&i==list.currentProcess-1">
                                 <img class="Rotation" style="width:14px;margin-left:4px;vertical-align: middle;" src="@/assets/img/salary/loading.png" /> 
                            </el-tooltip> <span v-if="i!=(list.process.length-1)">  -->
                                 
                                <el-tooltip placement="bottom" v-if="process.procLog.operResult!='10020002'">
                                    <span> {{process.segName}}</span>   
                                    <div slot="content">处理人姓名：{{process.procLog.perName}}<br/>处理时间：{{process.procLog.operTime}}</div>
                                </el-tooltip>
                               
                                <el-tooltip placement="bottom" v-else>
                                    <span style="color:red;"> {{process.segName}}<img style="width:14px;margin:0 4px;vertical-align: middle;" src="@/assets/img/salary/icon-tuipiao.png"  /></span>   
                                    <div slot="content">处理人姓名：{{process.procLog.perName}}<br/>处理时间：{{process.procLog.operTime}}<br/>失败原因：{{process.procLog.rejectReason}}</div>

                                         
                                     <!-- <img style="width:14px;margin-left:4px;vertical-align: middle;" src="@/assets/img/salary/icon-tuipiao.png"  />  -->

                                    
                                </el-tooltip>
                                <font v-if="i!=list.segList.length-1">></font> </span>
                        </span>
                    </div>
                        <slot></slot>
                    
                </div>
                <div>
                    <p>
                        <span class="label">工资月份</span>：{{list.wageMonth}}
                    </p>
                    <p>
                        <span class="label">社保月份</span>：{{list.socMonth}}
                    </p>
                    <p>
                        <span class="label">税金月份</span>：{{list.taxMonth}}
                    </p>
                    <p>
                        <span class="label">人数合计</span>：{{list.batchPerNum}}
                    </p>
                    <p>
                        <span class="label">总金额</span>：{{list.batchPayAccount}}
                    </p>
                    <p>
                        <span class="label">工资模板</span>：{{list.templateName}}
                    </p>
                </div>
            </div>
      </div>
      
</template>

<script>
  export default {
    name: "list",
    props: {
        list: {
            type: Object,
            default: '',
        }
    },
    data() {
      return {
         
      };
    },
    methods: {
  
    }
  };
</script>

<style scoped >
   .list{
       display:flex;
   }
   .list>div:nth-of-type(1){
       width:301px;
       border-right:2px solid #ddd;
       box-sizing: border-box;
   }
     .list>div:nth-of-type(2){
       flex-grow:1;
   }
   .list>div:nth-of-type(2)>div:nth-of-type(2){
       display:flex;
       flex-wrap:wrap;
       justify-content: space-between;
       padding-left:36px;
       padding-top:15px;
       
   }
   .list>div:nth-of-type(2) p{
       font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:17px;
        width:30%;
        padding-bottom:12px;
   }
   .listTop{
       height:34px;
       line-height:34px;
       background:rgba(241,241,241,1);
   }
   .listTop>span:nth-of-type(1){
       display:inline-block;
       width:144px;
       text-align:center;
       font-size:14px;
font-weight:400;
color:rgba(0,0,0,1);
line-height:20px;
   }
   .listTop>span:nth-of-type(2){
font-size:14px;
font-weight:500;
color:rgba(249,182,44,1);
line-height:20px;
   }
   .listCon p>span:nth-of-type(1){
        display:inline-block;
       width:144px;
       text-align:center;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:17px;
   }
   .listCon{
       padding:15px 0 5px;
   }
   .listCon p{
       padding-bottom:12px;
       height: 17px;
       line-height: 17px;
   }
    .listCon p>span:nth-of-type(2){
        display:inline-block;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:17px;
   }
   p>.label{
       width:50px;
   }
   .label{
       display: inline-block;
        height: 100%;
        min-width: 60px;
        text-align: justify;
        text-align-last: justify;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:17px;
   }
   .list .rightTop{
       position:relative;
       overflow:hidden;
         height:34px;
       line-height:34px;
       background:rgba(241,241,241,1);
   }
    .list .rightTop>div span{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        
    }
  
    .list .rightTop>div:nth-of-type(1){
        padding-left:36px;
    }
    .list .rightTop>div .current~span,.list .rightTop>div .current~span span,.list .rightTop>div .current font{
        color:#999!important;
    }
    .list .rightTop>div .current~span img{
        display:none
    }
     @-webkit-keyframes rotation {
            from {
                -webkit-transform: rotate(0deg);
            }
            to {
                -webkit-transform: rotate(360deg);
            }
        }

        .Rotation {
            -webkit-transform: rotate(360deg);
            animation: rotation 5s linear infinite;
            -moz-animation: rotation 5s linear infinite;
            -webkit-animation: rotation 5s linear infinite;
            -o-animation: rotation 5s linear infinite;
        }
</style>
